import EditComponent from './PurchaseMethodEdit';
import WebUniversal, { WUExtendPropsType } from '../../system/WebUniversalNewEx'
import { columnsheadId } from '../../universal/columnshead';

//组件 
const WebComponents = (props: any) => {

    /** api服务id */
    const apiId = 'purchaseMethod';

    //表头
    const columnsHead = [
        {
            title: '购置方式',
            dataIndex: 'purchaseMethodName'
        }
    ];

    const columns = columnsheadId
        .concat(columnsHead as []);

    let extendProps: WUExtendPropsType = {
        ...props,
        titleName: '购置方式',
        apiId,
        columns,
        showStates: true,
        pagination: true,
        EditComponent
    };

    return (
        <WebUniversal props={extendProps} />
    )
}

export default WebComponents;
